import AccountRepository from './AccountRepository';

const repositories = {
  accounts: AccountRepository,
};

export default {
  service: (name) => repositories[name],
};
